module.exports = {"name":"boardSearchEmptyStates","audiences":["allMembers"],"autoTrack":true,"experimentAllocation":0.1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/boardSearchEmptyStates.json
// module id = e4eC
// module chunks = 2